import routeMixin from '@/router/routeMixin'
import mixins from 'vue-typed-mixins'
import { FormulaireOutput } from './models/formulaire'

export default mixins(routeMixin).extend({
    data() {
        return {
            formulaires: [] as Array<FormulaireOutput>,
            formulaireEdite: null as FormulaireOutput | null
        }
    },
    methods: {
        loadFormulaires() {
            this.$loader.go()
            this.$http
                .api(`formulaire/all`)
                .get()
                .then(x => {
                    this.formulaires = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        save() {
            if (!this.formulaireEdite) return

            if (this.formulaireEdite.id == 0) {
                this.$http
                    .api(`formulaire`)
                    .post(this.formulaireEdite)
                    .then(response => {
                        this.$swal.toast.success()
                        this.loadFormulaires()
                        if (this.formulaireEdite) this.formulaireEdite.id = response.data
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            } else {
                this.$http
                    .api(`formulaire`)
                    .put(this.formulaireEdite)
                    .then(() => {
                        this.$swal.toast.success()
                        this.loadFormulaires()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            }
        },
        duplicate(id : number){
            this.$http
                .api(`formulaire/duplicate/${id}`)
                .get()
                .then(response => {
                    this.$swal.toast.success()
                    this.loadFormulaires()
                    this.formulaireEdite = response.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        cancel() {
            this.formulaireEdite = null
            this.loadFormulaires()
        },
        deleteFormulaire(form: FormulaireOutput) {
            this.$swal.confirm.delete().then(a => {
                if (!a.isConfirmed) return

                this.$http
                    .api(`formulaire`)
                    .deleteWithData(form.id)
                    .then(() => {
                        this.$swal.toast.success()
                        this.loadFormulaires()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        }
    },
    mounted() {
        this.loadFormulaires()
    }
})
